import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";

const MaterialDateTimePicker = ({
    value,
    onChange,
    variant,
    inputVariant,
    minDate,
    maxDate,
    clearable,
    hideOnNull
}) => {
    const [date, setDate] = useState(new Date(moment().startOf("day")));

    useEffect(() => {
        if (value) {
            setDate(value);
        }
    }, [value]);

    const handleDateChange = date => {
        onChange(date);
    };

    if (value === null && hideOnNull) {
        return (
            <div className="hide-on-null">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DateTimePicker
                        variant={variant}
                        inputVariant={inputVariant}
                        format="dd/MM/yyyy HH:mm"
                        value={date}
                        onChange={handleDateChange}
                        minDate={minDate}
                        maxDate={maxDate}
                        clearable={clearable}
                    />
                </MuiPickersUtilsProvider>
            </div>
        );
    } else {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                    variant={variant}
                    inputVariant={inputVariant}
                    format="dd/MM/yyyy HH:mm"
                    value={date}
                    onChange={handleDateChange}
                    minDate={minDate}
                    maxDate={maxDate}
                    clearable={clearable}
                />
            </MuiPickersUtilsProvider>
        );
    }
};

MaterialDateTimePicker.propTypes = {
    onChange: PropTypes.func.isRequired
};

export default MaterialDateTimePicker;
